import { render, staticRenderFns } from "./first_step.vue?vue&type=template&id=6b0bf74c&scoped=true&"
import script from "./first_step.vue?vue&type=script&lang=js&"
export * from "./first_step.vue?vue&type=script&lang=js&"
import style0 from "./first_step.vue?vue&type=style&index=0&id=6b0bf74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bf74c",
  null
  
)

export default component.exports